import { OTHERS_OPTION } from "./readmission-f2f-constant";
import { OptionGroupDef } from "./readmission-f2f-types";

export const REVIEW_OF_SYSTEMS_GROUPS: OptionGroupDef[] = [
  {
    key: "general",
    title: "General",
    options: [
      "Limited ambulation",
      "Obese",
      "Fatigue",
      "Weakness",
      "Fever",
      "Weight loss",
      "Weight gain",
      "Poor appetite",
      OTHERS_OPTION,
    ],
  },
  {
    key: "head",
    title: "Head",
    options: ["Vertigo", "Headache", "Dizziness", "Head injury", OTHERS_OPTION],
  },
  {
    key: "eyes",
    title: "Eyes",
    options: [
      "Vision changes",
      "Blurred vision",
      "Eye pain",
      "Eye redness",
      "Cataracts",
      OTHERS_OPTION,
    ],
  },
  {
    key: "ears",
    title: "Ears",
    options: [
      "Hearing impairment",
      "Deaf",
      "Tinnitus",
      "Ear pain",
      "Ear discharge",
      OTHERS_OPTION,
    ],
  },
  {
    key: "nose",
    title: "Nose",
    options: [
      "Congestion",
      "Runny nose",
      "Nosebleeds",
      "Loss of smell",
      "Sinus pain",
      OTHERS_OPTION,
    ],
  },
  {
    key: "mouth",
    title: "Mouth",
    options: [
      "Dry mouth",
      "Mouth sores",
      "Difficulty chewing",
      "Difficulty swallowing",
      "Dentures",
      OTHERS_OPTION,
    ],
  },
  {
    key: "cardiovascular",
    title: "Cardiovascular",
    options: [
      "Chest pain",
      "Palpitations",
      "Leg swelling",
      "Shortness of breath on exertion",
      "Orthopnea",
      OTHERS_OPTION,
    ],
  },
  {
    key: "pulmonary",
    title: "Pulmonary",
    options: [
      "Cough",
      "Shortness of breath",
      "Wheezing",
      "Sputum production",
      "Oxygen use",
      OTHERS_OPTION,
    ],
  },
  {
    key: "abdomen",
    title: "Abdomen",
    options: [
      "Abdominal pain",
      "Nausea",
      "Vomiting",
      "Diarrhea",
      "Constipation",
      "Urinary frequency",
      "Incontinence",
      OTHERS_OPTION,
    ],
  },
  {
    key: "mentalState",
    title: "Mental state",
    options: [
      "Depression",
      "Anxiety",
      "Confusion",
      "Memory loss",
      "Agitation",
      "Insomnia",
      OTHERS_OPTION,
    ],
  },
  {
    key: "safetyAssessment",
    title: "Safety assessment",
    options: [
      "Fall risk",
      "Lives alone",
      "Unsafe home environment",
      "Wandering",
      "Needs supervision",
      OTHERS_OPTION,
    ],
  },
];
